import { render, staticRenderFns } from "./HistoricUserForms.vue?vue&type=template&id=3e4fb3ca"
import script from "./HistoricUserForms.vue?vue&type=script&lang=js"
export * from "./HistoricUserForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports